import { Options } from 'services/api';

import Allowance from './Allowance';
import CostCenter from './CostCenter';
import Dashboard from './Dashboard';
import Department from './Department';
import ExpenseCode from './ExpenseCode';
import GiftCard from './GiftCard';
import Location from './Location';
import Order from './Order';
import Report from './Report';
import Subscription from './Subscription';
import UpgradePlan from './UpgradePlan';
import User from './User';

export default function initCompanyService(options: Options) {
  return {
    department: Department.getInstance(options),
    location: Location.getInstance(options),
    report: Report.getInstance(options),
    allowance: Allowance.getInstance(options),
    order: Order.getInstance(options),
    user: User.getInstance(options),
    subscription: Subscription.getInstance(options),
    expenseCode: ExpenseCode.getInstance(options),
    costCenter: CostCenter.getInstance(options),
    giftCard: GiftCard.getInstance(options),
    upgradePlan: UpgradePlan.getInstance(options),
    dashboard: Dashboard.getInstance(options)
    // list other services here
  };
}

export type CompanyServices = ReturnType<typeof initCompanyService>;
